<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-layout row wrap class="custom-mb">
            <v-flex sm12>
                <v-card>
                    <v-toolbar card color="white">
                        <v-toolbar-title>
                            <h3>Add Equipment Type</h3>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <router-link class="link-btn square-btn" :to="{name: 'EquipmentsList'}">
                            <v-icon color="black" medium>fa-chevron-left</v-icon>
                        </router-link>
                    </v-toolbar>
                    <breadcrumbs :items="breadcrumbs" divider=">"></breadcrumbs>
                    <v-divider></v-divider>
                    <v-card-text class="pa-0">
                        <v-form class="ldmx-form">
                            <v-container grid-list-xl fluid>
                                <v-layout row wrap>
                                    <v-flex lg6 md12 xs12>
                                        <v-text-field label="Code *" v-model="form.code" :maxlength="32" v-validate="{required: 'form.code', max: 32, no_special_char: 'form.code','restrictedWord':[]}" data-vv-name="code" placeholder="" :error-messages="errors.collect('code')" required>
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex lg6 md12 xs12>
                                        <v-text-field label="Name *" v-model="form.name" :maxlength="32" v-validate="{required: form.name, max: 32, no_special_char: 'form.name','restrictedWord':[]}" data-vv-name="name" placeholder="" :error-messages="errors.collect('name')">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex lg12 md12 xs12>
                                        <v-textarea label="Description" v-model="form.description" data-vv-name="description" placeholder="" v-validate="{'restrictedWord':[]}" :error-messages="errors.collect('description')">
                                        </v-textarea>
                                    </v-flex>
                                    <v-flex lg12 md12 xs12>
                                        <v-switch label="Primary" v-model="form.primary"></v-switch>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                   <v-flex lg12 xs12>
                                <h3>Aggregators</h3>
                                  </v-flex>
                                </v-layout>
                               
                                 <v-layout row wrap>
                                <template v-for="(item, index) in listAggregators">
                                    <v-card>
                                        <v-flex lg12  xs12>
                                            <h3 class="subheading">{{item.name}}</h3>
                                     
                                            <v-autocomplete
                                             class="auotchoice" 
                                             :items="item.AggregatorCode" 
                                             :error-messages="errors.collect(`aggregator[${index}][aggregator_code_id]`)" 
                                             :data-vv-name="`aggregator[${index}][aggregator_code_id]`" 
                                             v-model="selectedAggregatorCodeIds[index]" 
                                             data-vv-as="Aggregator Code" 
                                             item-text="mapped_name" item-value="Id" label="Aggregator Code" multiple 
                                             v-on:change="onAggCodeChange($event, item.Id)">
                                             <template
                                                    slot="selection"
                                                    slot-scope="data"
                                                >
                                                    <v-chip
                                                        data-vv-scope="form"
                                                        :selected="data.selected"
                                                        class="v-chip--select-multi"
                                                        @input="removeEquipmentChip(index,data.item.Id)"
                                                        close
                                                    >
                                                        {{ data.item.mapped_name }}
                                                    </v-chip>
                                                </template>
                                             </v-autocomplete>
                                        </v-flex>
                                  </v-card>
                                </template>
                                   </v-layout>
                            </v-container>
                            <div class="form-btn text-xs-right">
                                <v-btn color="gray  white--text" @click="$router.push('/equipments/list')"><v-icon color="white">fa-times-circle</v-icon>Cancel</v-btn>
                                <v-btn color="green  white--text" @click="submit"> Save </v-btn>
                            </div>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import GoogleAds from "@/pages/widgets/GoogleAds";
import services from "../../services/HttpService";
import breadcrumbs from "../widgets/Breadcrumb";
export default {
    $_veeValidate: {
        validator: "new"
    },
    beforeRouteLeave(to, from, next) {
        if (to.name === 'Login') {
            next();
        } else {
            if (this.canLeaveWithoutPrompt) {
                return next();
            }
            next(window.confirm('Do you really want to leave? You have unsaved changes!'));
        }
    },
    components: {
        breadcrumbs,
        GoogleAds
    },
    data: () => ({
        canLeaveWithoutPrompt: false,
        listAggregators: [],
        selectedAggregatorCodeIds: [],
        breadcrumbs: [{
                name: 'Dashboard',
                to: "/dashboard",
                disabled: false
            },
            {
                name: 'Reporting',
                to: "/comingsoon",
                disabled: false
            },
            {
                name: 'Equipment Types',
                to: "/equipments/list",
                disabled: false
            },
            {
                name: 'Add Equipment Type',
                disabled: true
            }
        ],
        form: {
            code: "",
            name: "",
            description: "",
            primary: false,
            aggregator: [],
        },
    }),
    mounted() {
        this.$validator.localize("en", this.dictionary);
    },
    created() {
        const self = this,
                wApp = window.getApp;
            wApp.$emit("showLoader", {
                show: true
            });
        services
            .get("aggregators/list", {
                Authorization: "Bearer " + this.$store.state.user.token
            })
            .then(res => {
                wApp.$emit("showLoader", {
                    show: false
                });
                if (res.status === 200) {
                    self.listAggregators = res.data.data;
                    res.data.data.map(function(data){
                        self.form.aggregator.push({aggregator_id:data.Id.toString(),aggregator_code_id:""});
                    });
                }
            })
            .catch(err => {
                wApp.$emit("showLoader", {
                    show: false
                });
                self._showToast(err.message, 'red');
            });
    },

    methods: {
        _showToast(msg, color) {
            window.getApp.$emit("showSnackbar", {
                color,
                msg
            });
        },
        removeEquipmentChip(index,equipmentTypeCodeId) {
            const self = this;
            let tmpArr = self.form.aggregator[index]['aggregator_code_id'].split(",").map(Number);
            let indexOf = tmpArr.indexOf(equipmentTypeCodeId);
            if (indexOf > -1) {
                tmpArr.splice(indexOf, 1);
                self.form.aggregator[index]['aggregator_code_id'] = tmpArr.join(',')
                self.selectedAggregatorCodeIds[index].splice(self.selectedAggregatorCodeIds[index].indexOf(equipmentTypeCodeId),1);
            }
        },
        onAggCodeChange(ids, aggregator_id){
            const self = this;
            self.form.aggregator.map(function(aggData, key){
                if(aggData.aggregator_id == aggregator_id){
                    self.form.aggregator[key].aggregator_code_id = ids.join(',');
                }
            })
        },
        submit() {
            const self = this,
                wApp = window.getApp;
            this.$validator
                .validateAll()
                .then(isValid => {
                    if (isValid) {
                        self.form.aggregator = JSON.stringify(self.form.aggregator);
                        wApp.$emit("showLoader", {
                            show: true
                        });
                        services
                            .post(
                                "equipments/new", self.form, {
                                    Authorization: "Bearer " + this.$store.state.user.token
                                }
                            )
                            .then(res => {
                                if (res.status === 200) {
                                    const isErr = res.data.is_error;
                                    self._showToast(res.data.message, isErr ? 'red' : 'green');
                                    wApp.$emit("showLoader", {
                                        show: false
                                    });
                                    if (isErr) {
                                        return;
                                    }
                                    self.canLeaveWithoutPrompt = true;
                                    self.$router.push("/equipments/list");
                                }
                            })
                            .catch(err => {
                                wApp.$emit("showLoader", {
                                    show: false
                                });
                                self._showToast(err.response.data.message, 'red');
                            });
                    }
                })
                .catch(err => {});
        },
        clear() {
            this.form = {};
            this.$validator.reset();
        },
    }
};
</script>



// WEBPACK FOOTER //
// src/pages/equipment/Add.vue